enum MmcNotificationGroupType {
  COMPANY = "company group",
  DEAL = "deal group",
  PERSON = "people group",
}

export default MmcNotificationGroupType;
